
import { Options, Vue } from 'vue-class-component'
import ServiceMeta from './ServiceMeta.vue'
import ServiceControl from './ServiceControl.vue'
import ServiceLogs from './ServiceLogs.vue'
import { useStore } from '@/store'
import axios from 'axios'
import { ServiceMeta as ServiceMetaData } from '../service-meta'
import { Configuration } from '@/configuration'

@Options({
  components: {
    ServiceMeta,
    ServiceControl,
    ServiceLogs
  }
})
export default class AdminWeb extends Vue {
  store = useStore()
  showConnectionErrorAlert = false

  async created (): Promise<void> {
    // eslint-disable-next-line no-eval
    const configuration = eval((await axios.get('./config.js')).data) as Configuration
    this.store.commit('setConfiguration', configuration)
  }

  private webSocketClosedOrError (): void {
    this.store.commit('setWebSocket', null)
    this.showConnectionErrorAlert = true
  }

  async connect (): Promise<void> {
    this.store.commit('clearLogs')
    if (this.store.state.webSocket !== null) {
      this.store.state.webSocket.close()
      this.store.commit('setWebSocket', null)
    }
    let res
    try {
      res = await axios.post(`${this.store.state.configuration.apiBase}${this.store.state.configuration.apiEndpoint}/token`, {
        token: this.store.state.token
      })
    } catch (err) {
      this.webSocketClosedOrError()
      return
    }
    if (res.status !== 200) {
      this.webSocketClosedOrError()
      return
    }
    const jwToken = res.data.token
    this.store.commit('setWebSocketJwt', jwToken)

    const url: URL = new URL(`${this.store.state.configuration.apiEndpoint}/websocket`, this.store.state.configuration.wsBase)
    url.searchParams.set('jwToken', jwToken)
    const webSocket: WebSocket = new WebSocket(url.toString())
    if (!webSocket) {
      this.webSocketClosedOrError()
      return
    }
    webSocket.onerror = () => {
      this.webSocketClosedOrError()
    }
    webSocket.onclose = () => {
      this.webSocketClosedOrError()
    }
    webSocket.onmessage = (message: MessageEvent) => {
      const messageData = JSON.parse(message.data)
      switch (messageData.type) {
        case 'meta': {
          const data = messageData.meta as ServiceMetaData
          if (this.store.state.serviceMeta.podTimestamp !== data.podTimestamp) {
            this.store.commit('clearLogs')
          }
          this.store.commit('updateServiceMeta', data)
          break
        }
        case 'log-previous': {
          this.store.commit('addPreviousLogLines', { lines: messageData.lines, limit: this.store.state.configuration.logLimit })
          break
        }
        case 'log-current': {
          this.store.commit('addCurrentLogLines', { lines: messageData.lines, limit: this.store.state.configuration.logLimit })
          break
        }
      }
    }
    this.store.commit('setWebSocket', webSocket)
    this.showConnectionErrorAlert = false
  }

  updateToken (event: Event): void {
    const target = event.target as HTMLInputElement
    this.store.commit('setToken', target.value)
  }
}
